/**
 * DAAily logo mark — used in header, login screen, PDFs (separately, in functions).
 *
 * The logo image lives at /public/logo.png. We render it as a plain <img>
 * with a sensible alt text. The bundle stays small (the PNG is ~10KB).
 */

interface LogoProps {
  className?: string;
  /** Follow the theme (ink logo in light, white in dark). Off by default so
   *  always-dark surfaces (the app-lock screen) keep the white variant. */
  themed?: boolean;
}

export function Logo({ className = 'h-12', themed = false }: LogoProps) {
  // Pre-rendered variants instead of CSS invert(): /logo-white.png (white on
  // transparent) and /logo.png (black; also used for PDFs via functions/assets).
  if (themed) {
    return (
      <>
        <img src="/logo.png" alt="DAAily platforms" className={`dark:hidden ${className}`} />
        <img src="/logo-white.png" alt="DAAily platforms" className={`hidden dark:block ${className}`} />
      </>
    );
  }
  return <img src="/logo-white.png" alt="DAAily platforms" className={className} />;
}
